import {useEffect, useState} from "react";

function slugify(text) {
    return text
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
}

function TableOfContent() {

    const [headings, setHeadings] = useState([]);

    useEffect(() => {
        const container = document.querySelector('.prose') || document;

        const scan = () => {
            const elements = Array.from(container.querySelectorAll('h2, h3, h4'));
            setHeadings(elements.map((elem, index) => {
                if (!elem.id) {
                    elem.id = slugify(elem.innerText) || `heading-${index}`;
                }
                return {id: elem.id, text: elem.innerText, level: elem.tagName};
            }));
        };

        scan();

        const observer = new MutationObserver(scan);
        observer.observe(container, {childList: true, subtree: true});

        return () => observer.disconnect();
    }, []);

    if (headings.length === 0) {
        return null;
    }

    return (
        <nav>
            <ul className="space-y-1">
                {headings.map(heading => (
                    <li key={heading.id} className={heading.level === 'H2' ? '' : 'ml-3'}>
                        <a href={'#' + heading.id} className="block text-sm text-gray-400 hover:text-blue-600">{heading.text}</a>
                    </li>
                ))}
            </ul>
        </nav>
    );
}

export default TableOfContent
